import { VALIDATION_RULES } from '../../../constants';

export const COMPLIANCE_MAX_FILE_BYTES = 5 * 1024 * 1024; // 5MB
export const COMPLIANCE_ALLOWED_MIME_TYPES: readonly string[] = [
  ...VALIDATION_RULES.FILE.ALLOWED_TYPES,
];
export const COMPLIANCE_ALLOWED_EXTENSIONS = [
  ...VALIDATION_RULES.FILE.ALLOWED_EXTENSIONS,
];

export const validateComplianceFile = (file: File): string | null => {
  if (!COMPLIANCE_ALLOWED_MIME_TYPES.includes(file.type)) {
    return `Tipo de archivo no válido. Solo se permiten: ${COMPLIANCE_ALLOWED_EXTENSIONS.join(
      ', ',
    )}`;
  }

  if (file.size > COMPLIANCE_MAX_FILE_BYTES) {
    const maxMb = Math.round(COMPLIANCE_MAX_FILE_BYTES / 1024 / 1024);
    return `El archivo es demasiado grande. Máximo: ${maxMb}MB.`;
  }

  const extension = `.${file.name.split('.').pop()?.toLowerCase()}`;
  if (!COMPLIANCE_ALLOWED_EXTENSIONS.includes(extension as never)) {
    return `Extensión no válida. Solo se permiten: ${COMPLIANCE_ALLOWED_EXTENSIONS.join(
      ', ',
    )}`;
  }

  return null;
};

export const computeFileSha256 = async (file: File): Promise<string> => {
  if (!crypto?.subtle) {
    throw new Error('El navegador no soporta hashing seguro.');
  }

  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
};
